<template>
	<div class="mainWrapper direct-purchase">
		<h1>Import Direct Purchase</h1>
		<div class="form" v-if="brands.length > 0">
			<div>
				<span class="label">BRAND</span>
				<b-autocomplete
					v-model="brandSuggestions"
					:data="filteredBrands"
					:open-on-focus="true"
					placeholder="Brand"
					field="name"
					@select="option => (selectedBrand = option)"
					class="brandAutocomplete"
					:disabled="selectedBrand"
				>
					<template slot="empty">No results found</template>
				</b-autocomplete>
			</div>

			<!-- FOC Checkbox - Always visible below BRAND selection -->
			<div v-if="selectedBrand">
				<span class="label">FREE OF CHARGE (FOC)</span>
				<b-checkbox v-model="globalFOC" @input="onFOCToggle">
					FOC Direct Purchase
				</b-checkbox>
			</div>

			<div v-if="selectedBrand">
				<span class="label">UPLOAD FILE</span>
				<b-field class="file">
					<input type="file" @change="loadTextFromFile" />
				</b-field>
			</div>

			<div v-if="product">
				<span class="label">ADD</span>
				<b-button type="is-info" icon-left="plus-circle-outline" @click="submit">ADD PRODUCT</b-button>
			</div>
		</div>

		<div class="transfer-date">
			<span class="label">RECEIVED DATE</span>
			<b-datepicker :date-formatter="dateFormatter" v-model="received_date" icon="calendar-today"> </b-datepicker>
		</div>

		<div class="list">
			<!-- v-if="products.length > 0" -->
			<div class="products-list header">
				<div>
					BD CODE
				</div>

				<div>
					BARCODE
				</div>

				<div>
					NAME
				</div>

				<div>
					PACKAGING
				</div>

				<div>
					QUANTITY
				</div>

				<div>
					REMARK
				</div>
			</div>

			<div v-for="(item, index) of products" v-bind:key="index" class="products-list">
				<div>
					{{ item.bd_code }}
				</div>

				<div>
					{{ item.barcode }}
				</div>

				<div>
					{{ item.name }}
				</div>

				<div>
					<b-dropdown :value="item.packaging_selection" :disabled="true" aria-role="list">
						<template #trigger>
							<b-button :label="item.packaging_selection || 'Select'" type="is-primary" :disabled="true" icon-right="menu-down" />
						</template>

						<b-dropdown-item v-for="option in item.availablePackagingOptions" :key="option.value" :value="option.value" aria-role="listitem">
							{{ option.label }}
						</b-dropdown-item>
					</b-dropdown>
				</div>

				<div>
					<input name="qtyInput" class="qtyInput" type="number" v-model="item.qty" disabled />
				</div>

				<div>
					<textarea name="remark" class="remark" placeholder="Remark" v-model="item.remark" disabled />
				</div>
			</div>
		</div>

		<div v-if="products.length > 0" class="detail-buttons-wrapper">
			<div></div>
			<div class="align-right">
				<button class="big-button" @click="save()">SAVE</button>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'AddDirectPurchase',
	data: function() {
		return {
			brands: [], // List of brands from API
			selectedBrand: null, // Selected brand
			bdcodeData: [], // API bdcode data
			searchData: [], // API Search data
			brandSuggestions: '', // List of brands
			product: null, // 1 selected product
			products: [], // Selected products
			name: null,
			supplier: null,
			received_date: null,
			content: null,
			globalFOC: false // FOC checkbox state
		}
	},
	computed: {
		filteredBrands() {
			return this.brands.filter(option => {
				return (
					option.name
						.toString()
						.toLowerCase()
						.indexOf(this.brandSuggestions.toLowerCase()) >= 0
				)
			})
		}
	},

	watch: {
		content: function() {
			this.verifyContent()
		},

		selectedBrand: function(newData) {
			this.product = null
			this.products = []
		}
	},

	mounted: async function() {
		// Get list of brands
		const data = {
			populate: ['suppliers']
		}

		const apiGetWarehouse = await this.$api.getWarehouse({ data })

		this.supplier = apiGetWarehouse.data.suppliers[0]._id

		// Get brands name which are related to this warehouse
		await Promise.all(
			apiGetWarehouse.data.suppliers[0].brand.map(async brand => {
				const brandData = {
					id: brand
				}

				const apiGetBrand = await this.$api.getBrand({ data: brandData })

				if (apiGetBrand !== undefined) {
					this.brands.push(apiGetBrand.data.list[0])
				}
			})
		)
	},

	methods: {
		verifyContent: async function() {
			for (var transfer of this.content) {
				const bdCode = transfer.bdCode
				const qty = transfer.qty
				const remark = transfer.remark
				const packaging = transfer.packaging || ''

				const data = {
					brand: this.selectedBrand._id,
					bd_code: bdCode
				}

				const apiProductDetail = await this.$api.searchProduct({ data })

				if (!apiProductDetail || apiProductDetail.data.count == 0) {
					this.$swal.fire('Error!', bdCode + ' is not in ' + this.selectedBrand.name + ' brand!', 'error')
					this.error = true
					return
				}

				let apiProduct = apiProductDetail.data.list[0]

				const duplicate = this.products.filter(product => {
					return product._id == apiProduct._id
				})

				if (duplicate.length > 0) {
					this.$swal.fire('Duplicate!', bdCode + ' is already added!', 'error')
					this.error = true
					return
				}

				// Set basic product data
				apiProduct.qty = qty
				apiProduct.remark = remark
				apiProduct.foc = this.globalFOC

				try {
					// Calculate available packaging options
					apiProduct.availablePackagingOptions = this.calculateProductPackagingOptions(apiProduct, packaging)

					// Get and validate packaging selection
					apiProduct.packaging_selection = this.getDefaultPackagingSelection(apiProduct, apiProduct.availablePackagingOptions, packaging)
				} catch (error) {
					this.$swal.fire('Error!', error.message, 'error')
					this.error = true
					return
				}

				this.products.push(apiProduct)
			}
		},

		// Load CSV and add into array
		loadTextFromFile(ev) {
			this.error = false
			const file = ev.target.files[0]
			const reader = new FileReader()

			let error = false
			let productData = []

			// reader.onload = e => this.$emit("load", e.target.result);
			reader.onload = event => {
				var raw = event.target.result.split(/\r?\n/)

				// Get header row and create column mapping
				const headerRow = raw[0]
				const headers = headerRow.split(/,/).map(h => h.trim().toUpperCase())

				// Expected headers: BD CODE, QUANTITY, PACKAGING, REMARK
				const bdCodeIndex = headers.indexOf('BD CODE')
				const quantityIndex = headers.indexOf('QUANTITY')
				const packagingIndex = headers.indexOf('PACKAGING')
				const remarkIndex = headers.indexOf('REMARK')

				// Validate required columns exist
				if (bdCodeIndex === -1 || quantityIndex === -1 || remarkIndex === -1) {
					this.$swal.fire('Error!', 'CSV must contain columns: BD CODE, QUANTITY, PACKAGING, REMARK', 'error')
					return
				}

				// Remove header row
				raw.shift()

				// Loop every row to put it in array
				raw.map(data => {
					if (!data.trim()) return // Skip empty rows

					var splitData = data.split(/,/)
					var newData = {}

					newData.bdCode = splitData[bdCodeIndex] ? splitData[bdCodeIndex].trim() : ''
					newData.qty = splitData[quantityIndex] ? splitData[quantityIndex].trim() : ''
					newData.packaging = packagingIndex >= 0 && splitData[packagingIndex] ? splitData[packagingIndex].trim() : ''
					newData.remark = splitData[remarkIndex] ? splitData[remarkIndex].trim() : ''

					// Validate required fields
					if (!newData.bdCode) {
						return // Skip rows without BD CODE
					}

					if (!newData.qty || newData.qty == '') {
						this.$swal.fire('Error!', newData.bdCode + ' quantity cannot be blank', 'error')
						error = true
						return
					}

					// Validate packaging based on FOC status
					if (this.globalFOC) {
						// FOC DP: packaging can be provided and will be validated against product options
						// Validation will happen during product lookup
					} else {
						// Non-FOC DP: packaging must be blank
						if (newData.packaging && newData.packaging !== '') {
							this.$swal.fire('Error!', newData.bdCode + ' packaging must be left blank for non-FOC Direct Purchase', 'error')
							error = true
							return
						}
					}

					if (newData.bdCode) {
						productData.push(newData)
					}
				})

				if (error == false) {
					this.content = productData
				}
			}

			reader.readAsText(file)
		},

		save: async function() {
			var newData = []

			this.products.map(product => {
				var productData = {}

				productData.product = product._id
				productData.received_date = this.$moment(this.received_date).format('DD/MM/YYYY')
				productData.supplier = this.supplier
				// productData.price = product.price;
				productData.currency = 'MMK'
				productData.qty = product.qty
				productData.remark = product.remark

				// Add FOC status - true if FOC is enabled, false otherwise
				productData.foc = product.foc || false

				// Add packaging selection for each product
				productData.packaging_selection = product.packaging_selection || 'single_item'

				newData.push(productData)
			})

			const data = {
				direct_purchase_items: newData
			}

			const apiSaveDP = await this.$api.saveDP({ data })

			if (apiSaveDP !== undefined) {
				this.$swal.fire(apiSaveDP.data.direct_purchase.code)

				this.$router.push('/direct-purchase')
			}
		},

		dateFormatter(dt) {
			return dt.toLocaleDateString('en-GB')
		},

		submit: async function() {
			this.product.received_date = null
			this.product.qty = null
			this.product.remark = null

			this.products.push(this.product)

			this.product = null
			this.searchData = []
		},

		update: function(index, item, value) {
			if (item == 'qty') {
				this.products[index].qty = Number(value)
			}

			// if (item == "price") {
			// 	this.products[index].price = Number(value);
			// }
		},

		// Autocomplete search
		searchProducts: async function(name) {
			if (name.length > 1) {
				const data = {
					brand: this.selectedBrand._id,
					bd_code: name
				}

				const apiSearchProduct = await this.$api.searchProduct({ data })

				this.searchData = apiSearchProduct.data.list
			}
		},

		// FOC toggle handler
		onFOCToggle: function() {
			if (this.products.length > 0) {
				this.$swal
					.fire({
						title: 'Warning!',
						text: 'Changing FOC status will reset all loaded products. Continue?',
						icon: 'warning',
						showCancelButton: true,
						confirmButtonColor: '#3085d6',
						cancelButtonColor: '#d33',
						confirmButtonText: 'Yes, reset products'
					})
					.then(result => {
						if (result.isConfirmed) {
							this.resetAllProducts()
						} else {
							// Revert FOC checkbox if cancelled
							this.globalFOC = !this.globalFOC
						}
					})
			}
		},

		// Reset all products
		resetAllProducts: function() {
			this.products = []
			this.content = null
		},

		// Calculate available packaging options for a specific product
		calculateProductPackagingOptions: function(product, csvPackaging = null) {
			const options = []

			try {
				// Check if we should include "Single Item" option
				if (!product.original_price_unit || product.original_price_unit === 'single_item') {
					options.push({ value: 'single_item', label: 'Single Item' })
				}

				// Add other packaging options based on availability
				if (product.packaging && product.packaging.box && product.packaging.box.price) {
					options.push({ value: 'box', label: 'Box' })
				}

				if (product.packaging && product.packaging.card && product.packaging.card.price) {
					options.push({ value: 'card', label: 'Card' })
				}

				if (product.packaging && product.packaging.pill && product.packaging.pill.price) {
					options.push({ value: 'pill', label: 'Pill' })
				}

				// Validate CSV packaging if provided (for FOC items)
				if (this.globalFOC && csvPackaging) {
					const validPackages = options.map(opt => opt.value)
					if (!validPackages.includes(csvPackaging)) {
						throw new Error(`Invalid packaging '${csvPackaging}' for product ${product.bd_code}. Available options: ${validPackages.join(', ')}`)
					}
				}

				return options
			} catch (error) {
				console.error('Error calculating packaging options:', error)
				return [{ value: 'single_item', label: 'Single Item' }]
			}
		},

		// Get default packaging selection
		getDefaultPackagingSelection: function(product, availableOptions, csvPackaging = null) {
			try {
				// For FOC items with CSV packaging, validate and use it
				if (this.globalFOC && csvPackaging) {
					const validOption = availableOptions.find(opt => opt.value === csvPackaging)
					if (validOption) {
						return csvPackaging
					} else {
						throw new Error(`Invalid packaging '${csvPackaging}' for product ${product.bd_code}`)
					}
				}

				// For non-FOC items, use original_price_unit
				if (!this.globalFOC) {
					if (product.original_price_unit) {
						const validOption = availableOptions.find(opt => opt.value === product.original_price_unit)
						if (validOption) {
							return product.original_price_unit
						}
					}
					// Default to single_item if original_price_unit not available
					return 'single_item'
				}

				// For FOC items without CSV packaging, use first available option
				return availableOptions.length > 0 ? availableOptions[0].value : 'single_item'
			} catch (error) {
				console.error('Error getting default packaging selection:', error)
				return 'single_item'
			}
		}
	}
}
</script>

<style scoped>
.transfer-date {
	width: 300px;
	margin-bottom: 2em;
}

.form {
	width: 500px;
	text-align: left;
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	grid-gap: 20px;
	width: 100%;
	margin-bottom: 40px;
}

span.label {
	font-size: 12px;
	font-weight: bold;
	color: #ccc;
	text-align: left;
	margin-bottom: 10px;
}

/* .products-list {
	margin-bottom: 20px;
	display: grid;

	grid-gap: 20px;
	width: 100%;
	text-align: left;
	font-weight: bold;
} */

.products-list {
	margin: auto;
	display: grid;
	grid-template-columns: 1fr 1fr 1fr 1fr 0.8fr 1fr;
	grid-gap: 10px;
	padding: 20px 5px;
	font-weight: bold;
	font-size: 14px;
	color: #000;
	border-bottom: 1px solid #eee;
}

.header {
	color: #aaa;
	font-weight: bold;
	font-size: 14px;
	margin-bottom: 10px;
}

.qtyInput {
	width: 90px;
	height: 30px;
	border: 0;
	text-align: center;
	border-radius: 5px;
	padding-left: 10px;
	font-size: 14px;
	font-weight: bold;
	color: #000;
	background-color: #f5f5f5;
	/* background: #70a15a; */
}

.priceInput {
	width: 150px;
	height: 30px;
	border: 0;
	text-align: center;
	border-radius: 5px;
	padding-left: 10px;
	font-size: 14px;
	font-weight: bold;
	color: #000;
	background-color: #f5f5f5;
}

.remark {
	width: 100%;
	height: 50px;
	border-radius: 4px;
	border: 1px solid #ccc;
	background-color: #fff;
	padding: 5px;
	color: #000;
	font-size: 14px;
	overflow-wrap: break-word;
}
</style>
